module.exports = __webpack_public_path__ + "static/media/sobre-nos.63c1dd3d.mp4";